import merge from 'lodash.merge';

function declination(n, titles) {
  return titles[n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
}

function formatAddress(address) {
  const sequence = ["city", "district", "street", "house", "apartment", "entrance", "floor"];
  const tmp = [];
  function appendHint(type, val) {
    if (type === "city")
      return `${val}`;
    else if (type === "district")
      return `${val}`;
    else if (type === "street")
      return `${val}`;
    else if (type === "house")
      return `\u0434\u043E\u043C ${val}`;
    else if (type === "apartment")
      return `\u043A\u0432. ${val}`;
    else if (type === "entrance")
      return `${val} \u043F\u043E\u0434\u044A\u0435\u0437\u0434`;
    else if (type === "floor")
      return `${val} \u044D\u0442\u0430\u0436`;
  }
  sequence.forEach((type) => {
    const val = address[type];
    if (val) {
      const text = appendHint(type, val);
      if (text)
        tmp.push(text);
    }
  });
  if (tmp.length > 0)
    return tmp.join(", ");
  else
    return "";
}

function formatPrice(val) {
  return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

function formatFileSize(bits) {
  const i = Math.floor(Math.log(bits) / Math.log(1024));
  return `${bits / +(1024 ** i).toFixed(2) * 1} ${["\u0431", "\u043A\u0431", "\u043C\u0431", "\u0433\u0431", "\u0442\u0431"][i]}`;
}

function formatPhoneAndMask(val) {
  let phoneNumber = val.replace(/[^\d]/g, "");
  if (phoneNumber[0] !== "8" && phoneNumber[0] !== "7")
    phoneNumber = `7${phoneNumber}`;
  else if (phoneNumber.length > 1)
    phoneNumber = `7${phoneNumber.substring(1)}`;
  else
    phoneNumber = "7";
  if (phoneNumber.length === 1) {
    return `+${phoneNumber[0]}`;
  } else if (phoneNumber.length < 5) {
    return `+${phoneNumber[0]} (${phoneNumber.substring(1)}`;
  } else if (phoneNumber.length < 8) {
    return `+${phoneNumber[0]} (${phoneNumber.substring(1, 4)}) ${phoneNumber.substring(4)}`;
  } else if (phoneNumber.length < 10) {
    return `+${phoneNumber[0]} (${phoneNumber.substring(1, 4)}) ${phoneNumber.substring(4, 7)}-${phoneNumber.substring(7)}`;
  } else {
    return `+${phoneNumber[0]} (${phoneNumber.substring(1, 4)}) ${phoneNumber.substring(4, 7)}-${phoneNumber.substring(
      7,
      9
    )}-${phoneNumber.substring(9, 11)}`;
  }
}

function getFormData(obj) {
  const data = new FormData();
  for (const prop in obj) {
    const el = obj[prop];
    if (el instanceof FileList || Array.isArray(el) && el.every((i) => i instanceof File)) {
      Array.from(el).forEach((el2) => {
        data.append(`${prop}[]`, el2);
      });
    } else if (Array.isArray(el)) {
      el.forEach((e) => {
        if (e instanceof Object)
          data.append(`${prop}[]`, JSON.stringify(e));
        else if (e !== void 0 && el !== null)
          data.append(`${prop}[]`, e.toString());
      });
    } else if (el instanceof File) {
      data.append(prop, el);
    } else if (el instanceof Object) {
      data.append(prop, JSON.stringify(el));
    } else if (el !== void 0 && el !== null) {
      data.append(prop, el.toString());
    }
  }
  return data;
}

function paginationArray({ visiblePageCount = 7, count, current, delimiter = "...", countDelimiterAsPage = true }) {
  let arr = createArray({ visiblePageCount, count, current });
  arr = appendSidePages({ arr, delimiter, countDelimiterAsPage });
  function createArray({ visiblePageCount: visiblePageCount2, count: count2, current: current2 }) {
    const arr2 = [current2];
    let i = 2;
    let rightFilled = false;
    let leftFilled = false;
    while (i <= visiblePageCount2) {
      if (leftFilled && rightFilled)
        break;
      if (i % 2 === 0 && !rightFilled || leftFilled)
        append();
      else if (i % 2 !== 0 && !leftFilled || rightFilled)
        prepend();
    }
    function append() {
      const num = arr2[arr2.length - 1] + 1;
      if (num <= count2) {
        arr2.push(num);
        i++;
      } else {
        rightFilled = true;
      }
    }
    function prepend() {
      const num = arr2[0] - 1;
      if (num >= 1) {
        arr2.unshift(num);
        i++;
      } else {
        leftFilled = true;
      }
    }
    return arr2;
  }
  function appendSidePages({ arr: arr2, delimiter: delimiter2, countDelimiterAsPage: countDelimiterAsPage2 }) {
    if (arr2.length !== visiblePageCount)
      return arr2;
    const lastPageNeeded = arr2[arr2.length - 1] !== count;
    const firstPageNeeded = arr2[0] !== 1;
    const offset = countDelimiterAsPage2 ? 2 : 1;
    if (lastPageNeeded)
      arr2 = [...arr2.slice(0, arr2.length - offset), delimiter2, count];
    if (firstPageNeeded)
      arr2 = [1, delimiter2, ...arr2.slice(offset, arr2.length)];
    return arr2;
  }
  return arr;
}

function conditionView({ identifyer, interval = 14, count = 1, showForCertainOS }) {
  const userAgent = navigator.userAgent.toLowerCase();
  let needToShow = false;
  if (isProperOS(showForCertainOS)) {
    const fromStore = window.localStorage.getItem(`\u0441onditions-view-${identifyer}`)?.split(",") || [];
    const startDate = fromStore[0] && new Date(fromStore[0]);
    const showCount = fromStore[1] && parseInt(fromStore[1]);
    if (startDate && showCount) {
      if (daysPassed(startDate) >= interval && showCount > 1) {
        window.localStorage.setItem(`\u0441onditions-view-${identifyer}`, JSON.stringify([new Date().toISOString(), showCount - 1]));
        needToShow = true;
      }
    } else {
      window.localStorage.setItem(`\u0441onditions-view-${identifyer}`, JSON.stringify([new Date().toISOString(), count]));
      needToShow = true;
    }
  }
  function isProperOS(os) {
    if (os) {
      if (Array.isArray(os))
        return os.some((el) => !!userAgent.includes(el.toLowerCase()));
      else
        return !!userAgent.includes(os.toLowerCase());
    } else {
      return true;
    }
  }
  function daysPassed(startDate) {
    const start = startDate.getTime();
    const current = new Date().getTime();
    return Math.round((current - start) / 1e3 / 60 / 60 / 24);
  }
  function isNeedToShow() {
    return needToShow;
  }
  return {
    isNeedToShow
  };
}

function getWidthWithMargin(el) {
  return el.getBoundingClientRect().width + parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
}

function createFactory(data) {
  return (param) => {
    return merge({}, data, typeof param === "function" ? param() : param);
  };
}

function createListFactory(data) {
  return (count, param) => {
    return new Array(count).fill(null).map((_, index) => {
      return merge({}, data, typeof param === "function" ? param(index) : param);
    });
  };
}

export { conditionView, createFactory, createListFactory, declination, formatAddress, formatFileSize, formatPhoneAndMask, formatPrice, getFormData, getWidthWithMargin, paginationArray };
